"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = void 0;
require("../../core");
const isEmpty = (value) => {
    if (value instanceof Map || value instanceof Set) {
        return !value.size;
    }
    if (Array.isArray(value)) {
        return !value.length;
    }
    // it could be needed but I'm not sure. i'll keep it anyway:
    // [Object, Array].includes((obj || {}).constructor)
    return !Object.entries(value || {}).length;
};
exports.isEmpty = isEmpty;
//# sourceMappingURL=isEmpty.js.map